import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import moment from "moment";
import { PaginationLimit } from "../../Config";
import { capitalizeFirstLetter, getDueTypeLabel, truncateText } from "../../helpers";
import Tooltip from "../Tooltip";

const PayableTable = ({
    apiData,
    setSelectedData,
    setIsMarkPaidExpense,
}) => {

    const [data, setData] = useState([
        {
            deviceName: "",
            extractionTime: "",
            processingTime: "",
            drops: "",
            action: "",
        },
    ]);

    const [selectedRow, setSelectedRow] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [currentPage, setCurrentPage] = useState(0);
    const [openActionMenu, setOpenActionMenu] = useState(null);

    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };


    const markPaid = (item) => {
        setIsMarkPaidExpense(true);
        setSelectedData(item);
    };

    useEffect(() => {
        if (apiData) {
            const tempData = apiData.map((item) => ({
                name: getName(item),
                dueDate: dueDate(item),
                createDate: createDate(item),
                description: getDescription(item),
                amountBalance: getAmount(item),
                markAsPaid: markAsPaid(item),
            }));
            setData(tempData);
        }
    }, [apiData, openActionMenu]);

    const getAmount = (item) => {
        return (
            <Amount >{'₹' + item.amount}</Amount>
        );
    };

    const getDescription = (item) => {
        return (
            <span className="text-gray-600 text-sm">{item?.description ? truncateText(item?.description, 20) : 'N/A'}</span>
        );
    };

    const getName = (item) => {
        const expenseTypeName = capitalizeFirstLetter(item?.expenseTypeName);
        return (
            <UserImageWrapper>
                {item?.expenseTitle ?
                    <Tooltip label={
                        <div className="text-xs leading-5">
                            <div>Expense Title: {item?.expenseTitle}</div>
                        </div>
                    }>
                        <div className="flex flex-col gap-1">
                            <span className="text-gray-600 text-sm">
                                {truncateText(expenseTypeName, 25)}{""}
                            </span>
                            <span className="text-gray-400 text-xs"> {item.createdAt ? moment(item.createdAt).format("DD, MMM YY") : "---"}</span>
                        </div>
                    </Tooltip>
                    :
                    <div className="flex flex-col gap-1">
                        <span className="text-gray-600 text-sm">
                            {truncateText(expenseTypeName, 25)}{""}
                        </span>
                        <span className="text-gray-400 text-xs"> {item.createdAt ? moment(item.createdAt).format("DD, MMM YY") : "---"}</span>
                    </div>
                }
            </UserImageWrapper>
        );
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const dueDate = (item) => {
        return (
            <div className="flex flex-col text-sm text-gray-600">
                <span>
                    {item.dueDate ? moment(item.dueDate).format("DD, MMM YY") : "---"}
                </span>
            </div>
        );
    };

    const createDate = (item) => {
        return (
            <div className="flex flex-col text-sm text-gray-600">
                <span>
                    {item.createdAt ? moment(item.createdAt).format("DD, MMM YY") : "---"}
                </span>
            </div>
        );
    };

    const markAsPaid = (item) => {
        return (
            <div className="flex gap-4 ">
                <button
                    onClick={() => markPaid(item)}
                    className="
            text-sm px-3 py-1 rounded-full
            border border-gray-400 text-gray-500
            hover:bg-gray-100 hover:border-gray-500
            transition"
                >
                    Mark as Paid
                </button>
            </div>
        );
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const columns = React.useMemo(() => {
        if (isMobileView) {
            return [
                {
                    Header: "Expense",
                    accessor: "name",
                },

                {
                    Header: "Balance",
                    accessor: "amountBalance",
                },
            ];
        }
        return [
            {
                Header: "Expense",
                accessor: "name",
            },
            {
                Header: "Balance",
                accessor: "amountBalance",
            },

            {
                Header: "Due Date",
                accessor: "dueDate",
            },

            {
                Header: "Mark As Paid",
                accessor: "markAsPaid",

            },
            {
                Header: "Desc",
                accessor: "description",

            },
            // {
            //     Header: "Created On",
            //     accessor: "createDate",
            // },

        ];
    }, [isMobileView]);
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex },
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );

    useEffect(() => {
        setCurrentPage(pageIndex);
    }, [pageIndex]);

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}
                                >
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                onClick={() => {
                                                    if (
                                                        cellIndex === 0 ||
                                                        (cellIndex === 1 && window.innerWidth < 768)
                                                    ) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}
                                            >
                                                {typeof cell.value === "function"
                                                    ? cell.value()  // render dynamic function
                                                    : cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2 ">
                                                <li>
                                                    <strong>Description</strong> {data[rowIndex].description}
                                                </li>
                                                <li>
                                                    <strong>Due Date</strong> {data[rowIndex].dueDate}
                                                </li>

                                                <li>
                                                    <strong>Mark ad Paid</strong>{" "}
                                                    {data[rowIndex].markAsPaid}
                                                </li>

                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {apiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>

                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}


        </>
    );
};

const UserImageWrapper = tw.div` flex items-center gap-2`;
const UserImage = tw.img`w-9 h-9 rounded-full `;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Amount = tw.p`
  text-rose-600 font-semibold
  bg-rose-50 px-3 py-1
  rounded-full inline-flex
  cursor-pointer
`;

export default PayableTable;
